// Image upload utility - uses external API
export const uploadImage = async (imageFile, project = 'oesweb', type = 'questions') => {
  try {
    const formData = new FormData();
    formData.append('image', imageFile);
    formData.append('project', project);
    formData.append('type', type);

    // Try HTTPS first (more likely to work with CORS)
    const apiUrl = 'https://imageapi.garanipublication.com/upload.php';
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        url: result.url
      };
    } else {
      throw new Error(result.error || 'Upload failed');
    }
  } catch (error) {
    console.error('Image upload error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Delete image from server
export const deleteImage = async (imageUrl) => {
  try {
    // Skip deletion for base64 images
    if (imageUrl.startsWith('data:image')) {
      return { success: true, message: 'Base64 image removed from local storage' };
    }

    const formData = new FormData();
    formData.append('url', imageUrl);

    const apiUrl = 'https://imageapi.garanipublication.com/delete.php';
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      mode: 'cors',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Delete failed with status: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      return {
        success: true,
        message: result.message || 'Image deleted successfully'
      };
    } else {
      throw new Error(result.error || 'Delete failed');
    }
  } catch (error) {
    console.error('Image delete error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Alternative: Convert image to base64 for temporary storage
export const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
